import { Card, CardContent } from '@crestrewards/ui';

/**
 * The centred card every signed-out screen sits in — sign in, forgot password,
 * reset password.
 *
 * An internal piece of the auth feature (PROJECT_SPEC.md §4.2 allows these
 * beside the routed pages). Nothing outside `features/auth/` imports it; if a
 * second feature ever needs it, it moves to `shared/layout/` first.
 */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          {/* One of the three sanctioned homes for the brand gradient. */}
          <span
            aria-hidden="true"
            className="grid h-11 w-11 place-items-center rounded-lg bg-brand-gradient text-lg font-bold text-white"
          >
            C
          </span>
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-foreground">{title}</h1>
            {subtitle ? (
              <p className="mt-1 text-meta text-muted-foreground">{subtitle}</p>
            ) : null}
          </div>
        </div>

        <Card>
          <CardContent className="pt-6">{children}</CardContent>
        </Card>

        {footer ?? (
          <p className="mt-6 text-center text-label text-muted-foreground">
            Internal tool. Access is restricted to CrestRewards staff.
          </p>
        )}
      </div>
    </div>
  );
}
